export function getEntityList(urlParams) {
  
  let string = '';
  
  Object.keys(urlParams).forEach(param => {
    const [entity, ladokid] = param.toUpperCase().split('_');

    string += `${entity}|`
  })

  return string
}

export function getDepartmentList(urlParams) {
  
  let string = '';
  
  Object.keys(urlParams).forEach(param => {
    const [entity, ladokid] = param.toUpperCase().split('_');

    string += `${entity}/${ladokid}|`
  })

  return string
}

export function getEnrollmentList(enrolledIn) {
  let newApiParams = ''
  let newEntityParams = ''
  const newUrlParams = {}

  for (const [department, entity] of Object.entries(enrolledIn)) {
    newApiParams += `${entity}/${department}|` 
    newEntityParams += `${entity}|`
    newUrlParams[`${entity}_${department}`.toLowerCase()] = 1
  }

  return [newApiParams, newEntityParams, newUrlParams]
}